import React, { useCallback, useEffect, useState } from 'react';
import "./styles.css"
import { Icon } from '@material-ui/core';
import ReactResizeDetector from 'react-resize-detector';

var abrirFecharElemento = []
var pastasPai = []
var observer = null
var tabNivel = 0

const ICONE_FECHADO = "arrow_right"
const ICONE_ABERTO = "arrow_drop_down"

const Documentos = (props) => {

    const [sumary, setSumary] = useState([])
    const [abrirOuFecharSumario, setAabrirOuFecharSumario] = useState(true)
    const [linkVisivel, setLinkVisivel] = useState()
    const [frameSize, setFrameSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (!props.visualizarDocumentoId) return
        (async () => {
            setTimeout(function () {
                var el = document.querySelector(`[data-idParametro="${props.visualizarDocumentoId.parametroid}"]`)
                if (el) window.location.href = "#" + el.id;
            }, 200);
        })()
    }, [props.visualizarDocumentoId])

    useEffect(() => {
        setAabrirOuFecharSumario(props.abrirOuFecharSumario)
    }, [props.abrirOuFecharSumario])

    const montaJsonArraySumario = useCallback((parentId) => {
        const json = Array.from(document.querySelectorAll('[data-parent="' + parentId + '"]')).map(item => ({ id: item.id, descricao: item.innerText, parentId, cacheTime: 0 }))
        json.forEach(item => {
            item['itens'] = montaJsonArraySumario(item.id)
        });
        return json
    }, [])

    const getNivel = useCallback((id) => {
        const element = document.getElementById(id)
        if (!element) return tabNivel
        const parentId = element.getAttribute("data-parent")
        if (parentId) {
            tabNivel = tabNivel + 1
            getNivel(parentId)
        }
        return tabNivel - 1
    }, [])

    const recuperaFilhos = useCallback((iconeId, somenteUmNivel) => {
        const elements = Array.from(document.querySelectorAll('[data-parent="sumaryParent' + iconeId + '"]'))

        if (somenteUmNivel) return elements

        elements.forEach(element => {
            recuperaFilhos(element.id.split("Item")[1])
            abrirFecharElemento.push(element)
        })
        return abrirFecharElemento
    }, [])

    const abrirFechar = useCallback((itemId) => {
        abrirFecharElemento = []
        let display
        const icone = document.getElementById("icon" + itemId)

        if (icone.innerText === ICONE_FECHADO) {
            icone.innerText = ICONE_ABERTO
            display = "flex"
        } else {
            icone.innerText = ICONE_FECHADO
            display = "none"
        }

        let somenteUmNivel = false
        if (display === "flex") somenteUmNivel = true

        recuperaFilhos(itemId, somenteUmNivel).forEach(element => {
            element.style.display = display

            const span = element.getElementsByTagName("span")
            if (span.length > 0) span[0].innerText = ICONE_FECHADO
        })
    }, [recuperaFilhos])

    const montaItem = useCallback((item, ehPasta) => {
        observer && observer.observe(document.querySelector('[id="' + item.id + '"]'));

        tabNivel = 0
        const nivel = getNivel(item.id)

        let icon = null
        const classNameIcone = 'tab' + nivel
        let classNameLink = 'tab' + nivel

        if (ehPasta) {
            classNameLink = 'tab0'
            icon = <Icon id={"icon" + item.id} style={{ fontSize: 20, color: "rgba(255,255,255,0.75)" }} className={classNameIcone} onClick={() => abrirFechar(item.id)} >{ICONE_FECHADO}</Icon>
        } else {
            if (nivel === 0)
                classNameLink = 'tab1'
            else
                classNameLink = 'tab' + (nivel + 2)
        }

        const divItem =
            <div key={"sumaryItem" + item.id} id={"sumaryItem" + item.id} className="divItensSumario" data-parent={"sumaryParent" + item.parentId} >
                {icon}
                <a
                    key={item.id}
                    className={classNameLink}
                    href={"#" + item.id}
                    style={{ color: "#FFF" }}
                    onClick={() => setAabrirOuFecharSumario(false)}>
                    {item.descricao}
                </a>
            </div>
        return divItem
    }, [abrirFechar, getNivel])

    const montaElementosReact = useCallback((itens) => {
        itens.forEach(item => {
            if (item.itens.length > 0) {
                setSumary(old => [...old, montaItem(item, true)])
                montaElementosReact(item.itens)
            } else {
                setSumary(old => [...old, montaItem(item, false)])
            }
        })
    }, [montaItem])

    useEffect(() => {
        (async () => {
            setSumary([])
            const respose = await fetch("documento.html")
            const html = await respose.text()
            document.getElementById("divhtml").innerHTML = html

            criarObervador()
            montaElementosReact(montaJsonArraySumario("0"))

            if (props.visualizarDocumentoId) window.location.href = "#" + props.visualizarDocumentoId.parametroid;
        })()
    }, [montaElementosReact, montaJsonArraySumario, props.visualizarDocumentoId])

    const recuperarPastasPais = useCallback((id) => {
        const elemento = document.querySelector('[id="sumaryItem' + id + '"]')
        if (!elemento) return
        pastasPai.push(elemento)
        const parentPaiId = elemento.getAttribute('data-parent')
        recuperarPastasPais(parentPaiId.split('sumaryParent')[1])
        return pastasPai
    }, [])

    const recuperarTodasAsPastas = useCallback(() => {
        const pastas = []
        const elementsClassTab0 = document.getElementsByClassName("tab0")
        for (const key in elementsClassTab0) {
            if (elementsClassTab0[key].constructor.name === "HTMLSpanElement")
                pastas.push(elementsClassTab0[key])
        }
        return pastas
    }, [])

    const fecharTodasAsPastas = useCallback(() => {
        const pastas = recuperarTodasAsPastas()
        if (pastas.length === 0) return
        pastas.forEach(pasta => {
            pasta.innerText = ICONE_ABERTO
            abrirFechar(pasta.id.split("icon")[1])
        })
    }, [abrirFechar, recuperarTodasAsPastas])

    const selecionarItemPorLinkVisivel = useCallback(() => {
        const elementosPastaPai = recuperarPastasPais(linkVisivel)
        if (!elementosPastaPai || elementosPastaPai.length === 0) return

        if (elementosPastaPai.length === 1 && elementosPastaPai[0].children.length === 1) {
            elementosPastaPai[0].children[0].style.background = "#FFF"
            elementosPastaPai[0].children[0].style.color = "rgb(11, 126, 122)"
            elementosPastaPai[0].children[0].style.paddingLeft = "4px"
            elementosPastaPai[0].children[0].style.paddingRight = "4px"
            elementosPastaPai[0].children[0].style.borderRadius = "6px"
            return
        }

        elementosPastaPai.reverse().forEach((elemento, index) => {
            const numElementos = elementosPastaPai.length
            if (numElementos !== 1 && elemento.children.length === 2) {
                abrirFechar(elemento.id.split('sumaryItem')[1])
            }
            if (((numElementos - 1) === index)) {
                let childIndex = 0;
                if (elemento.children[0].text === undefined) {
                    childIndex = 1;
                }
                elemento.children[childIndex].style.background = "#FFF"
                elemento.children[childIndex].style.color = "rgb(11, 126, 122)"
                elemento.children[childIndex].style.paddingLeft = "4px"
                elemento.children[childIndex].style.paddingRight = "4px"
                elemento.children[childIndex].style.borderRadius = "6px"
            }
        })
    }, [abrirFechar, linkVisivel, recuperarPastasPais])

    useEffect(() => {
        if (!sumary) return
        fecharTodasAsPastas()

        pastasPai = []
        selecionarItemPorLinkVisivel()
    }, [sumary, abrirOuFecharSumario, fecharTodasAsPastas, selecionarItemPorLinkVisivel])

    const criarObervador = () => {
        let options = {
            root: document.querySelector('[id="raiz"]'),
            rootMargin: "0px",
            threshold: [1.0]
        };

        let callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting)
                    setLinkVisivel(entry.target.id)
            });
        };

        observer = new IntersectionObserver(callback, options);
    }

    return <div>
        {abrirOuFecharSumario &&
            <div className="parent">
                <div
                    className="divHTMLBackground"
                    onClick={() => { setAabrirOuFecharSumario(false) }}
                    style={{ width: frameSize.width, height: frameSize.height, backgroundColor: "rgba(0,0,0,0.7)" }} />
                <div className="root">
                    <div className="divSumario" style={{ height: frameSize.height - 20 }}>

                        <h4 style={{ fontFamily: "sans-serif", color: "#FFF" }}>Sumário</h4>

                        {sumary.length > 0 &&
                            sumary.map(item => item)
                        }

                    </div>
                </div>
                <ReactResizeDetector
                    handleWidth
                    handleHeight
                    onResize={(width, height) =>
                        setFrameSize({ width: width, height: height })
                    } />
            </div>
        }
        <div id="divhtml" />
    </div>
}

export default Documentos